import { useTranslation } from 'react-i18next';

import { OppvarmingFormData } from '../../types';

export const useOppvarmingValidation = () => {
  const { t } = useTranslation();

  const validateOppvarmingSelection = (_: boolean, formValues: OppvarmingFormData) => {
    const { elektrisk, bioenergi, olje, gass, ved, solfanger, varmepumpe, fjernvarme } = formValues;

    if (
      !elektrisk?.selected &&
      !bioenergi?.selected &&
      !olje?.selected &&
      !gass?.selected &&
      !ved?.selected &&
      !solfanger?.selected &&
      !varmepumpe?.selected &&
      !fjernvarme?.selected
    ) {
      return t('form.oppvarming.oppvarmingSelection.error');
    }
    return true;
  };

  return { validateOppvarmingSelection };
};
